// src/pages/LoginPage.tsx
import React, { useMemo, useState } from "react";
import { useAuth } from "../../core/auth";
import * as styles from "./LoginPage.module.scss";
import LogoZeus from "../../assets/icons/logo-zeus.svg";
import { ZeusButton, ZeusTypography, ZeusLoader } from "zeus-front-design-system";
import FloatingLabelInput from "../../componets/FloatingLabelInput/FloatingLabelInput";
import { useToast } from "../../hook/useToast";
const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// min 8, 1 mayus, 1 minus, 1 número, 1 especial
const passRe = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formErr, setFormErr] = useState<string | null>(null);
  const [fieldErrs, setFieldErrs] = useState<{ email?: string; pwd?: string }>({});
  const [errorGradient, setErrorGradient] = useState(false);
  const toast = useToast();

  const canSubmit = useMemo(() => email && pwd, [email, pwd]);

  const validate = () => {
    const errs: typeof fieldErrs = {};
    if (!emailRe.test(email)) {
      errs.email = "Ingresa un correo válido";
      toast.error("Ingresa un correo válido", "Revisa el formato de tu correo");
    }
    if (!passRe.test(pwd)) {
      errs.pwd = "Ingresa una contraseña valida";
      toast.error("Ingresa una contraseña valida", "Revisa el formato de tu contraseña");
    }
    setFieldErrs(errs);
    return Object.keys(errs).length === 0;
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormErr(null);
    setErrorGradient(false);
    if (!validate()) return;

    setSubmitting(true);
    try {
      const resp = await login(email, pwd);
      // listo: el guard te llevará a /
    } catch (err: any) {
      // if (err?.message === "DO-VAL-001") {
      //   setFieldErrs({ email: "", pwd: "¡Tu contraseña es incorrecta, intenta de nuevo!" });
      // } else if (err?.message === "SE-UNK-001") {
      //   setFieldErrs({ email: "¡Tu correo es incorrecto, intenta de nuevo!", pwd: "" });
      // } else {
      //   setFormErr(err?.message || "Ocurrió un error, intenta de nuevo más tarde");
      // }
      toast.error("Correo o contraseña incorrecta", "Revisa tus credenciales e intenta de nuevo");
      setFormErr("Correo o contraseña incorrecta");

      setErrorGradient(true); // cambia degradado en error
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.wrap} data-error={errorGradient ? "1" : "0"}>
      {submitting && (
        <div className={styles.loaderOverlay}>
          <ZeusLoader />
        </div>
      )}

      <div className={styles.loginContainer}>
        <main className={styles.card}>
          <header className={styles.cardHeader}>
            <LogoZeus id="app-logo" className={styles.logo} aria-label="Zeus" />
          </header>

          <ZeusTypography
            component="h1"
            type="Title"
            style="bold"
            size="medium"
            color="var(--brand)"
          >
            ¡Bienvenido a Zeus!
          </ZeusTypography>

          <form onSubmit={onSubmit} noValidate>
            <FloatingLabelInput
              label="Correo electrónico"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={fieldErrs.email}
              className={styles.emailInput}
            />

            <FloatingLabelInput
              label="Contraseña"
              type="password"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              error={fieldErrs.pwd}
              className={styles.pwdInput}
            />

            <ZeusButton
              textContent={"Iniciar sesión"}
              type="submit"
              disabled={!canSubmit}
              withArrow={false}
              className={styles.submitButton}
              styles={{ height: 32, width: "100%", maxWidth: 270 }}
            />

            {formErr && (
              <ZeusTypography
                component="div"
                type="Caption"
                size="medium"
                color="error"
                className={styles.formErr}
              >
                {formErr}
              </ZeusTypography>
            )}
          </form>
        </main>

        <div className={styles.bgImage}></div>
      </div>
    </div>
  );
}
